import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.addEventListener("DOMContentLoaded", function() {
  const currentPath = window.location.pathname;
  document.body.setAttribute("data-page", currentPath);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Removi o React.StrictMode por que os componentes de bibliotecas externas como o potree estavam duplicando
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
